import type { ObjPathProxy } from "ts-object-path";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

export enum PortfolioTab {
	Portfolio = 0,
	Documents = 1,
}

type LabelProxy = ObjPathProxy<unknown, string>;

export type PortfolioTabConfig = {
	tab: PortfolioTab;
	id: string;
	labelKey: LabelProxy;
};

export const PORTFOLIO_TABS: PortfolioTabConfig[] = [
	{
		tab: PortfolioTab.Portfolio,
		id: "portfolio",
		labelKey: Resources.Portfolio.Titles.portfolio,
	},
	{
		tab: PortfolioTab.Documents,
		id: "documents",
		labelKey: Resources.Portfolio.Titles.document,
	},
];

export const PORTFOLIO_TAB_STORAGE_KEY = "portfolio-tab";

export const PORTFOLIO_TAB_VALUES: PortfolioTab[] = PORTFOLIO_TABS.map(
	(tab) => tab.tab,
);
